import { render } from "./addPayment.vue?vue&type=template&id=4f25037f"
import script from "./addPayment.vue?vue&type=script&lang=js"
export * from "./addPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__